import React from 'react';
import { ShoppingCart } from 'lucide-react';
interface CTAButtonProps {
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode;
  showIcon?: boolean;
  href?: string;
}
export function CTAButton({
  className = '',
  onClick,
  children,
  showIcon = true,
  href
}: CTAButtonProps) {
  const handleClick = () => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }
    if (onClick) {
      onClick();
      return;
    }
    const element = document.getElementById('offer-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <button onClick={handleClick} className={`
        cta-animate group relative inline-flex items-center justify-center gap-3 
        bg-coral hover:bg-coral-hover text-white 
        font-body font-semibold text-lg md:text-xl
        py-4 px-8 rounded-full shadow-md hover:shadow-lg
        transition-all duration-300 ease-in-out transform hover:-translate-y-0.5
        ${className}
      `} data-id="element-31">
      {showIcon && <ShoppingCart className="w-5 h-5 transition-transform group-hover:scale-110 relative z-10" data-id="element-32" />}
      <span className="relative z-10" data-id="element-33">
        {children || 'Descargar la Guía por solo $6.36'}
      </span>
    </button>;
}